import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "20",
  fill: "none",
  viewBox: "0 0 21 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#667085",
      d: "m15.181 4.974 1.212-1.211L17.57 4.94l-1.21 1.213a7.5 7.5 0 1 1-1.178-1.179M10.5 16.667a5.833 5.833 0 1 0 0-11.666 5.833 5.833 0 0 0 0 11.666m-.833-10h1.666v5H9.667zM7.167.834h6.666v1.667H7.167z"
    }, null, -1)
  ]))]))
}
export default { render: render }